// Utility function to migrate existing project customers to the customers collection
import { db } from '../lib/firebase';
import { collection, getDocs, addDoc, updateDoc, doc, query, where, serverTimestamp } from 'firebase/firestore';

export const migrateProjectCustomersToCollection = async () => {
  try {
    console.log('Starting customer migration...');
    
    // Get all projects
    const projectsSnapshot = await getDocs(collection(db, 'projects'));
    const projects = projectsSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    
    console.log(`Found ${projects.length} projects to check`);
    
    let created = 0;
    let updated = 0;
    let skipped = 0;
    
    for (const project of projects) {
      if (project.customer && project.customer.email) {
        const customerEmail = project.customer.email;
        
        // Check if customer already exists
        const customersQuery = query(
          collection(db, 'customers'),
          where('email', '==', customerEmail)
        );
        const customerSnapshot = await getDocs(customersQuery);
        
        let customerId;
        
        if (customerSnapshot.empty) {
          // Create new customer
          const customerData = {
            name: project.customer.name || '',
            email: customerEmail,
            phone: project.customer.phone || '',
            company: project.customer.company || '',
            address: '',
            notes: `Customer imported from project: ${project.name}`,
            createdAt: project.createdAt || serverTimestamp(),
            updatedAt: serverTimestamp()
          };
          
          const customerDocRef = await addDoc(collection(db, 'customers'), customerData);
          customerId = customerDocRef.id;
          created++;
          console.log(`Created customer: ${customerData.name} (${customerEmail})`);
        } else {
          // Customer exists
          customerId = customerSnapshot.docs[0].id;
          updated++;
          console.log(`Customer already exists: ${customerEmail}`);
        }
        
        // Update project with customerId if it doesn't have one
        if (!project.customerId) {
          await updateDoc(doc(db, 'projects', project.id), {
            customerId: customerId,
            'customer.id': customerId,
            updatedAt: serverTimestamp()
          });
          console.log(`Updated project ${project.name} with customerId`);
        }
      } else {
        skipped++;
        console.log(`Skipped project ${project.name} - no customer data`);
      }
    }
    
    console.log('Migration complete!');
    console.log(`Created: ${created} customers`);
    console.log(`Already existed: ${updated} customers`);
    console.log(`Skipped: ${skipped} projects`);
    
    return {
      success: true,
      created,
      updated,
      skipped
    };
  } catch (error) {
    console.error('Error during migration:', error);
    return {
      success: false,
      error: error.message
    };
  }
};